import Dexie from 'dexie'

const db = new Dexie('localDB')
db.version(1).stores({
    logins: `login`
})

export default db
